import React, { useEffect, useState, createElement } from 'react';
import { Link } from 'react-router-dom';
import { Search, TrendingUp, TrendingDown, Sparkles, LineChart, ArrowUpRight, ChevronRight, Shield, Leaf, FileText, Activity, CheckCircle2, ChevronLeft, AlertCircle, Network } from 'lucide-react';
import { AppCard } from '../components/base/AppCard';
import { AppBadge } from '../components/base/AppBadge';
import { MiniSparkline } from '../components/charts/MiniSparkline';
const SLIDES = [{
  id: 1,
  badge: 'Azione richiesta',
  title: '1 Anomalia Rilevata',
  desc: 'Il servizio Customer Assistant sta generando costi superiori alla media.',
  btnText: 'Verifica anomalia',
  icon: Activity,
  colorClass: 'bg-red-500/80',
  bgGlow: 'bg-red-500/10'
}, {
  id: 2,
  badge: 'Suggerimento',
  title: 'Nuovo Modello',
  desc: 'Passa a GPT-4o-mini per risparmiare il 40% sui costi di inferenza.',
  btnText: 'Scopri di più',
  icon: Sparkles,
  colorClass: 'bg-[#00B4D8]/80',
  bgGlow: 'bg-[#00B4D8]/10'
}, {
  id: 3,
  badge: 'Compliance',
  title: 'Update AI Act',
  desc: 'Nuove linee guida disponibili per la classificazione del rischio dei modelli.',
  btnText: 'Leggi policy',
  icon: Shield,
  colorClass: 'bg-amber-500/80',
  bgGlow: 'bg-amber-500/10'
}];
export function CostManagementPage() {
  const [activeTab, setActiveTab] = useState('In evidenza');
  const [expandedCard, setExpandedCard] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % SLIDES.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  return <div className="min-h-screen bg-[#F4F6F8] p-4 md:p-8" data-id="element-2123">
      {/* Header Section */}
      <div className="flex flex-col lg:flex-row justify-between items-stretch gap-8 mb-10" data-id="element-2124">
        <div className="flex-1 flex flex-col justify-center" data-id="element-2125">
          <h1 className="md:text-[32px] text-[#1A202C] tracking-tight mb-3 text-[28px] font-[600]" data-id="element-2126">
            Ciao, Marco!
            <br data-id="element-2127" />
            Ecco il riepilogo della tua infrastruttura AI.
          </h1>
          <p className="text-[14px] text-gray-600 max-w-2xl mb-5 leading-relaxed" data-id="element-2128">
            I costi mostrano un picco insolito, mentre compliance e
            sostenibilità sono nella norma.
          </p>
          <div className="flex flex-wrap items-center gap-3 mb-6" data-id="element-2129">
            <div className="flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-200 rounded-lg shadow-sm" data-id="element-2130">
              <Activity className="w-4 h-4 text-[#00B4D8]" data-id="element-2131" />
              <span className="text-[13px] font-medium text-gray-700" data-id="element-2132">
                12 Servizi Monitorati
              </span>
            </div>
            <div className="flex items-center gap-2 px-3 py-1.5 bg-red-50 border border-red-100 rounded-lg shadow-sm" data-id="element-2133">
              <AlertCircle className="w-4 h-4 text-red-500" data-id="element-2134" />
              <span className="text-[13px] font-medium text-red-700" data-id="element-2135">
                1 Richiede Attenzione
              </span>
            </div>
            <Link to="/canvas" className="flex items-center gap-2 px-3 py-1.5 bg-[#2A3B5C] text-white rounded-lg shadow-sm hover:bg-[#1E2A40] transition-colors" data-id="element-2136">
              <Network className="w-4 h-4" data-id="element-2137" />
              <span className="text-[13px] font-medium" data-id="element-2138">Vai alla Mappa AI</span>
              <ArrowUpRight className="w-3 h-3 opacity-70" data-id="element-2139" />
            </Link>
          </div>
        </div>

        {/* Status Slider Card */}
        <div className="relative w-full lg:w-[420px] min-h-[200px] rounded-2xl bg-gradient-to-br from-[#2A3B5C] to-[#1E2A40] border border-[#2A3B5C]/20 overflow-hidden flex flex-col p-6 shrink-0 shadow-lg group" data-id="element-2140">
          {/* Abstract decorative shapes - Dynamic based on slide */}
          <div className={`absolute top-[-20%] right-[-10%] w-48 h-48 rounded-full blur-3xl mix-blend-screen pointer-events-none transition-colors duration-1000 ${SLIDES[currentSlide].bgGlow}`} data-id="element-2141"></div>
          <div className={`absolute bottom-[-10%] left-[20%] w-40 h-40 rounded-full blur-3xl mix-blend-screen pointer-events-none transition-colors duration-1000 ${SLIDES[currentSlide].bgGlow}`} data-id="element-2142"></div>

          <div className="relative z-10 flex-1 flex flex-col justify-between" data-id="element-2143">
            <div className="flex items-center justify-between mb-2" data-id="element-2144">
              <span className="text-white/60 text-[12px] uppercase tracking-wider font-medium" data-id="element-2145">
                Notifiche di Sistema
              </span>
              <span className="flex items-center gap-1.5 text-white text-[12px] font-medium bg-white/10 px-2.5 py-1 rounded-full border border-white/20 backdrop-blur-md transition-all duration-500" data-id="element-2146">
                {createElement(SLIDES[currentSlide].icon, {
                className: 'w-3.5 h-3.5'
              })}
                {SLIDES[currentSlide].badge}
              </span>
            </div>

            {/* Carousel Content */}
            <div className="mt-4 relative h-[70px] overflow-hidden" data-id="element-2147">
              {SLIDES.map((slide, index) => <div key={slide.id} className={`absolute inset-0 transition-all duration-500 ease-in-out ${index === currentSlide ? 'opacity-100 translate-x-0' : index < currentSlide ? 'opacity-0 -translate-x-full' : 'opacity-0 translate-x-full'}`} data-id="element-2148">
                  <h2 className="text-white font-heading font-bold tracking-tight text-[28px]" data-id="element-2149">
                    {slide.title}
                  </h2>
                  <p className="text-white/70 text-[13px] mt-1 max-w-[280px]" data-id="element-2150">
                    {slide.desc}
                  </p>
                </div>)}
            </div>

            {/* Bottom Section: Button & Pagination */}
            <div className="mt-6 flex items-center justify-between" data-id="element-2151">
              <button className="flex items-center gap-2 px-5 py-2.5 rounded-xl bg-white/10 backdrop-blur-md border border-white/20 text-white text-[13px] font-medium hover:bg-white/20 transition-colors shadow-lg" data-id="element-2152">
                <span className={`flex items-center justify-center min-w-[20px] h-[20px] text-white rounded-full text-[11px] font-bold transition-colors duration-500 ${SLIDES[currentSlide].colorClass}`} data-id="element-2153">
                  {currentSlide + 1}
                </span>
                {SLIDES[currentSlide].btnText}
                <ArrowUpRight className="w-4 h-4 text-white/70 ml-1" data-id="element-2154" />
              </button>

              {/* Pagination Dots */}
              <div className="flex items-center gap-1.5" data-id="element-2155">
                {SLIDES.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`h-1.5 rounded-full transition-all duration-300 ${index === currentSlide ? 'w-4 bg-white' : 'w-1.5 bg-white/30 hover:bg-white/50'}`} data-id="element-2156" />)}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs Section */}
      <div className="border-b-2 border-gray-300 mb-6" data-id="element-2157">
        <div className="-mb-[2px] flex items-center gap-8 overflow-x-auto custom-scrollbar" data-id="element-2158">
          {['In evidenza', 'Per te', 'Tutti i servizi'].map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`pb-3 text-[16px] transition-colors whitespace-nowrap border-b-2 ${activeTab === tab ? 'border-[#00B4D8] text-[#2A3B5C]' : 'border-transparent text-gray-500 hover:text-gray-800'}`} data-id="element-2159">
              {tab}
            </button>)}
        </div>
      </div>

      {/* Metric Cards Section - Netflix-style Accordion */}
      <div className="flex flex-col lg:flex-row gap-6 lg:h-[420px]" data-id="element-2160">
        {/* Card 1: Gestione Costi */}
        <div onMouseEnter={() => setExpandedCard(0)} className={`bg-white border border-gray-200 rounded-2xl p-6 flex flex-col relative overflow-hidden cursor-pointer transition-all duration-500 ease-in-out shadow-sm hover:shadow-md ${expandedCard === 0 ? 'flex-[2]' : 'flex-1'}`} data-id="element-2161">
          <div className="flex items-start justify-between mb-4 relative z-10" data-id="element-2162">
            <h3 className="text-[16px] font-semibold text-[#1A202C] whitespace-nowrap flex items-center gap-2" data-id="element-2163">
              <LineChart className="w-4 h-4 text-[#00B4D8]" data-id="element-2164" />
              Gestione Costi
            </h3>
            <AppBadge variant="default" className="bg-red-50 text-red-600 border border-red-100 shrink-0" data-id="element-2165">
              Da verificare
            </AppBadge>
          </div>

          <div className="relative z-10" data-id="element-2166">
            <p className="font-heading font-bold text-[#1A202C] text-[28px]" data-id="element-2167">
              € 2.435
            </p>
          </div>

          {/* Collapsed Preview */}
          <div className={`transition-all duration-500 ease-in-out overflow-hidden ${expandedCard === 0 ? 'max-h-0 opacity-0' : 'max-h-[100px] opacity-100'}`} data-id="element-2168">
            <div className="pt-3" data-id="element-2169">
              <div className="flex items-center gap-1.5 text-[12px] text-red-600 font-medium mb-2" data-id="element-2170">
                <TrendingUp className="w-3.5 h-3.5" data-id="element-2171" /> +17% vs media
              </div>
              <div className="mb-2" data-id="element-2172">
                <MiniSparkline data={[10, 12, 15, 14, 20, 25, 30]} color="#ef4444" className="h-[24px]" data-id="element-2173" />
              </div>
              <p className="text-[12px] text-gray-500 leading-snug line-clamp-1" data-id="element-2174">
                Picco su Customer Assistant.
              </p>
            </div>
          </div>

          {/* Expanded Content */}
          <div className={`transition-all duration-500 ease-in-out flex flex-col ${expandedCard === 0 ? 'flex-1 max-h-[400px] mt-4' : 'max-h-0 mt-0'} overflow-hidden`} data-id="element-2175">
            <div className={`transition-opacity duration-500 ease-in-out flex flex-col flex-1 ${expandedCard === 0 ? 'opacity-100 delay-150' : 'opacity-0'}`} data-id="element-2176">
              {/* Custom Inline SVG Chart */}
              <div className="w-full h-[100px] mt-auto relative z-10 text-[#00B4D8] mb-4 shrink-0" data-id="element-2177">
                <svg viewBox="0 0 400 120" className="w-full h-full overflow-visible" preserveAspectRatio="none" data-id="element-2178">
                  {/* Background faded bars */}
                  <g opacity="0.1" fill="currentColor" data-id="element-2179">
                    {Array.from({
                    length: 40
                  }).map((_, i) => {
                    const height = 40 + Math.sin(i * 0.3) * 10 + (i > 30 ? (i - 30) * 4 : 0);
                    return <rect key={i} x={i * 10} y={120 - height} width="6" height={height} rx="2" data-id="element-2180" />;
                  })}
                  </g>

                  <line x1="300" y1="10" x2="300" y2="120" stroke="#CBD5E0" strokeWidth="1" strokeDasharray="4 4" data-id="element-2181" />

                  <path d="M 0 90 Q 50 100, 100 80 T 200 95 T 300 85 L 390 30" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-2182" />

                  <text x="0" y="75" fill="#718096" fontSize="12" fontWeight="500" data-id="element-2183">
                    1.3K
                  </text>
                  <text x="365" y="20" fill="#718096" fontSize="12" fontWeight="500" data-id="element-2184">
                    1.6K
                  </text>
                </svg>
              </div>

              <p className="text-[13px] text-gray-600 leading-relaxed mb-4" data-id="element-2185">
                Picco di spesa rilevato nel servizio Customer Assistant (+17%
                rispetto alla media).
              </p>

              <div className="flex flex-col gap-2 mt-auto" data-id="element-2186">
                <button className="w-full flex items-center justify-center px-6 py-3 bg-[#2A3B5C] text-white rounded-md hover:bg-[#1E2A40] transition-colors" data-id="element-2187">
                  <span className="text-[15px] font-heading uppercase tracking-wide whitespace-nowrap" data-id="element-2188">
                    Analisi Dettagliata
                  </span>
                </button>
                <button className="w-full flex items-center justify-center px-6 py-3 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors" data-id="element-2189">
                  <span className="text-[15px] font-heading uppercase tracking-wide whitespace-nowrap" data-id="element-2190">
                    Ottimizza Costi
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Card 2: Compliance */}
        <div onMouseEnter={() => setExpandedCard(1)} className={`bg-white border border-gray-200 rounded-2xl p-6 flex flex-col cursor-pointer overflow-hidden transition-all duration-500 ease-in-out shadow-sm hover:shadow-md ${expandedCard === 1 ? 'flex-[2]' : 'flex-1'}`} data-id="element-2191">
          <div className="flex items-start justify-between mb-4" data-id="element-2192">
            <h3 className="text-[16px] font-semibold text-[#1A202C] whitespace-nowrap flex items-center gap-2" data-id="element-2193">
              <Shield className="w-4 h-4 text-[#00B4D8]" data-id="element-2194" />
              Compliance
            </h3>
            <AppBadge variant="default" className="bg-emerald-50 text-emerald-600 border border-emerald-100 shrink-0" data-id="element-2195">
              Conforme
            </AppBadge>
          </div>

          <div data-id="element-2196">
            <p className="font-heading font-bold text-[#1A202C] text-[28px]" data-id="element-2197">
              98%
            </p>
          </div>

          {/* Collapsed Preview */}
          <div className={`transition-all duration-500 ease-in-out overflow-hidden ${expandedCard === 1 ? 'max-h-0 opacity-0' : 'max-h-[100px] opacity-100'}`} data-id="element-2198">
            <div className="pt-3 flex flex-col gap-2" data-id="element-2199">
              <div className="w-full bg-gray-100 rounded-full h-1.5 mb-1" data-id="element-2200">
                <div className="bg-emerald-500 h-1.5 rounded-full" style={{
                width: '98%'
              }} data-id="element-2201"></div>
              </div>
              <span className="text-[12px] text-gray-600 flex items-center gap-1.5" data-id="element-2202">
                <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500" data-id="element-2203" /> 0
                violazioni
              </span>
              <span className="text-[12px] text-gray-600 flex items-center gap-1.5" data-id="element-2204">
                <Shield className="w-3.5 h-3.5 text-emerald-500" data-id="element-2205" /> Rischio
                Basso
              </span>
            </div>
          </div>

          {/* Expanded Content */}
          <div className={`transition-all duration-500 ease-in-out flex flex-col ${expandedCard === 1 ? 'flex-1 max-h-[400px] mt-4' : 'max-h-0 mt-0'} overflow-hidden`} data-id="element-2206">
            <div className={`transition-opacity duration-500 ease-in-out flex flex-col flex-1 ${expandedCard === 1 ? 'opacity-100 delay-150' : 'opacity-0'}`} data-id="element-2207">
              <div className="flex flex-wrap gap-2 mb-4" data-id="element-2208">
                <span className="text-[11px] text-gray-600 flex items-center gap-1 bg-gray-100 px-2.5 py-1 rounded-full w-fit font-medium" data-id="element-2209">
                  <CheckCircle2 className="w-3 h-3 text-emerald-500" data-id="element-2210" /> 0
                  violazioni critiche
                </span>
                <span className="text-[11px] text-gray-600 flex items-center gap-1 bg-gray-100 px-2.5 py-1 rounded-full w-fit font-medium" data-id="element-2211">
                  <CheckCircle2 className="w-3 h-3 text-emerald-500" data-id="element-2212" /> 100% log
                  conservati
                </span>
                <span className="text-[11px] text-gray-600 flex items-center gap-1 bg-gray-100 px-2.5 py-1 rounded-full w-fit font-medium" data-id="element-2213">
                  <Shield className="w-3 h-3 text-emerald-500" data-id="element-2214" /> Rischio AI
                  Act: Basso
                </span>
              </div>

              <p className="text-[13px] text-gray-600 leading-relaxed mb-4" data-id="element-2215">
                Tutti i servizi operativi rispettano i requisiti normativi.
                Ultimo audit superato con successo.
              </p>

              <div className="flex flex-col gap-2 mt-auto" data-id="element-2216">
                <button className="w-full flex items-center justify-center px-6 py-3 bg-[#2A3B5C] text-white rounded-md hover:bg-[#1E2A40] transition-colors" data-id="element-2217">
                  <span className="text-[15px] font-heading uppercase tracking-wide whitespace-nowrap" data-id="element-2218">
                    Vedi Audit Trail
                  </span>
                </button>
                <button className="w-full flex items-center justify-center px-6 py-3 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors" data-id="element-2219">
                  <span className="text-[15px] font-heading uppercase tracking-wide whitespace-nowrap" data-id="element-2220">
                    Report AI Act
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Card 3: GreenOps */}
        <div onMouseEnter={() => setExpandedCard(2)} className={`bg-white border border-gray-200 rounded-2xl p-6 flex flex-col cursor-pointer overflow-hidden transition-all duration-500 ease-in-out shadow-sm hover:shadow-md ${expandedCard === 2 ? 'flex-[2]' : 'flex-1'}`} data-id="element-2221">
          <div className="flex items-start justify-between mb-4" data-id="element-2222">
            <h3 className="text-[16px] font-semibold text-[#1A202C] whitespace-nowrap flex items-center gap-2" data-id="element-2223">
              <Leaf className="w-4 h-4 text-[#00B4D8]" data-id="element-2224" />
              GreenOps
            </h3>
            <AppBadge variant="default" className="bg-emerald-50 text-emerald-600 border border-emerald-100 shrink-0" data-id="element-2225">
              Ottimizzato
            </AppBadge>
          </div>

          <div data-id="element-2226">
            <p className="font-heading font-bold text-[#1A202C] text-[28px]" data-id="element-2227">
              124 kg CO₂
            </p>
          </div>

          {/* Collapsed Preview */}
          <div className={`transition-all duration-500 ease-in-out overflow-hidden ${expandedCard === 2 ? 'max-h-0 opacity-0' : 'max-h-[100px] opacity-100'}`} data-id="element-2228">
            <div className="pt-3" data-id="element-2229">
              <div className="flex items-center gap-1.5 text-[12px] text-emerald-600 font-medium mb-2" data-id="element-2230">
                <TrendingDown className="w-3.5 h-3.5" data-id="element-2231" /> -15% vs mese scorso
              </div>
              <div className="mb-2" data-id="element-2232">
                <MiniSparkline data={[30, 28, 25, 22, 18, 15, 12]} color="#10b981" className="h-[24px]" data-id="element-2233" />
              </div>
              <p className="text-[12px] text-gray-500 leading-snug line-clamp-1" data-id="element-2234">
                Routing dinamico SLM attivo.
              </p>
            </div>
          </div>

          {/* Expanded Content */}
          <div className={`transition-all duration-500 ease-in-out flex flex-col ${expandedCard === 2 ? 'flex-1 max-h-[400px] mt-4' : 'max-h-0 mt-0'} overflow-hidden`} data-id="element-2235">
            <div className={`transition-opacity duration-500 ease-in-out flex flex-col flex-1 ${expandedCard === 2 ? 'opacity-100 delay-150' : 'opacity-0'}`} data-id="element-2236">
              <div className="mb-4" data-id="element-2237">
                <span className="text-[12px] text-emerald-700 flex items-center gap-1 bg-emerald-50 border border-emerald-100 px-2.5 py-1 rounded-full w-fit font-medium" data-id="element-2238">
                  <TrendingDown className="w-3 h-3" data-id="element-2239" /> -15% vs mese scorso
                </span>
              </div>

              <p className="text-[13px] text-gray-600 leading-relaxed mb-4" data-id="element-2240">
                Risparmiati 45 kg di CO₂ questo mese grazie al routing dinamico
                verso modelli più efficienti (SLM).
              </p>

              <div className="flex flex-col gap-2 mt-auto" data-id="element-2241">
                <button className="w-full flex items-center justify-center px-6 py-3 bg-[#2A3B5C] text-white rounded-md hover:bg-[#1E2A40] transition-colors" data-id="element-2242">
                  <span className="text-[15px] font-heading uppercase tracking-wide whitespace-nowrap" data-id="element-2243">
                    Dettaglio Emissioni
                  </span>
                </button>
                <button className="w-full flex items-center justify-center px-6 py-3 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors" data-id="element-2244">
                  <span className="text-[15px] font-heading uppercase tracking-wide whitespace-nowrap" data-id="element-2245">
                    Suggerimenti Eco
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}